import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import CreditApplicationsDataGrid from './CreditApplicationsDataGrid'
import DashboardFooter from './DashboardFooter'
import DashboardHeader from './DashboardHeader'
import FileUploadStatusProvider from './FileUploadStatusProvider'
import styles from './styles.module.scss'

const Dashboard = () => {
  const [getClassName] = useNameFormatter('Dashboard')

  return (
    <FileUploadStatusProvider>
      <div className={styles[getClassName('')]}>
        <DashboardHeader />
        <CreditApplicationsDataGrid />
        <DashboardFooter />
      </div>
    </FileUploadStatusProvider>
  )
}

export default Dashboard
